import { applySpec, prop, pipe } from 'ramda';
import Option from './option';
import adoptDevice from './device';

/** @enum */
export const Contract = {
	ID: 'ID',
	INDEX: 'INDEX',
	DEFECT: 'DEFECT',
	DEFECT_REASON: 'DEFECT_REASON',
	CAN_PRINT: 'CAN_PRINT',
	CONDITION: 'CONDITION',
	CONCLUSION_MASTER: 'CONCLUSION_MASTER',
	COMMENT: 'COMMENT',
	CONCLUSION_TECHNICAL_CONTROL: 'CONCLUSION_TECHNICAL_CONTROL',
	DISPOSITION: 'DISPOSITION',
	STATUS: 'STATUS',
	CAN_EDIT: 'CAN_EDIT',
	REJECTION_REASON: 'REJECTION_REASON',
	FORM_TYPE: 'FORM_TYPE',
	IS_REJECTED: 'IS_REJECTED',
	IS_CONFIRMED: 'IS_CONFIRMED',
	IS_PRINTED: 'IS_PRINTED',
	AGREED_DATE: 'AGREED_DATE',
	BRAND: 'BRAND',
	MODEL: 'MODEL',
	REQUEST_NUMBER: 'REQUEST_NUMBER',
	SERIAL: 'SERIAL',
}

/**
 * @typedef Act
 * @property { string } id
 * @property { string } actNumber
 * @property { string } defect
 * @property { object } defectReason
 * @property { boolean } canPrint
 * @property { object } condition
 * @property { string } conclusion
 * @property { string } comment
 * @property { string } techControl
 * @property { string } disposition
 * @property { string } status
 * @property { boolean } canEdit
 * @property { string } rejectionReason
 * @property { string } formType
 * @property { boolean } isConfirmed
 * @property { boolean } isRejected
 * @property { boolean } isPrinted
 * @property { string } date
 * @property { import('./device').Device } device
 */

export default applySpec({
	id: prop(Contract.ID),
	actNumber: prop(Contract.INDEX),
	defect: prop(Contract.DEFECT),
	defectReason: pipe(
		prop(Contract.DEFECT_REASON),
		Option
	),
	canPrint: prop(Contract.CAN_PRINT),
	condition: pipe(
		prop(Contract.CONDITION),
		Option
	),
	conclusion: prop(Contract.CONCLUSION_MASTER),
	comment: prop(Contract.COMMENT),
	techControl: prop(Contract.CONCLUSION_TECHNICAL_CONTROL),
	disposition: prop(Contract.DISPOSITION),
	status: prop(Contract.STATUS),
	canEdit: prop(Contract.CAN_EDIT),
	rejectionReason: prop(Contract.REJECTION_REASON),
	formType: prop(Contract.FORM_TYPE),
	isConfirmed: prop(Contract.IS_CONFIRMED),
	isRejected: prop(Contract.IS_REJECTED),
	isPrinted: prop(Contract.IS_PRINTED),
	date: prop(Contract.AGREED_DATE),
	device: adoptDevice,
	requestNumber: prop(Contract.REQUEST_NUMBER),
});
